<template>
  <div class="topix-soporte-tickets">
    <Breadcrumbs :title="pageTitle" :main="'Centro de atención'" />
    <div class="container-fluid">
      <div class="row">
        <SupportTicketSidebar
          :tickets="tickets"
          :active-ticket-id="activeTicketId"
          :author-type="authorType"
          :sidebar-title="pageTitle"
          :loading="loadingList"
          :load-error="listError"
          @select="selectTicket"
        />
        <div class="col call-chat-body">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-0">
              <div class="row chat-box">
                <SupportTicketChat
                  :ticket="activeTicket"
                  @updated="onTicketUpdated"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/layout/breadCrumbs.vue';
import SupportTicketChat from '@/components/support/SupportTicketChat.vue';
import SupportTicketSidebar from '@/components/support/SupportTicketSidebar.vue';
import { fetchSupportTicketById, fetchSupportTickets } from '@/services/supportTicketsApi';

export default {
  name: 'SoporteAppTicketsPage',
  components: { Breadcrumbs, SupportTicketSidebar, SupportTicketChat },
  data() {
    return {
      tickets: [],
      activeTicketId: '',
      activeTicket: null,
      loadingList: false,
      loadingDetail: false,
      listError: '',
    };
  },
  computed: {
    authorType() {
      return this.$route.meta.supportAuthorType || 'CLIENT';
    },
    pageTitle() {
      return this.$route.meta.sectionTitle || 'Tickets de soporte';
    },
  },
  watch: {
    '$route.path'() {
      this.resetAndLoad();
    },
  },
  created() {
    this.loadTickets();
  },
  methods: {
    async resetAndLoad() {
      this.activeTicketId = '';
      this.activeTicket = null;
      await this.loadTickets();
    },
    async loadTickets() {
      this.loadingList = true;
      this.listError = '';
      try {
        this.tickets = await fetchSupportTickets(this.authorType);
        if (this.activeTicketId) {
          const stillExists = this.tickets.some((t) => t.id === this.activeTicketId);
          if (!stillExists) {
            this.activeTicketId = '';
            this.activeTicket = null;
          }
        }
        if (!this.activeTicketId && this.tickets.length) {
          await this.selectTicket(this.tickets[0].id);
        }
      } catch (e) {
        this.tickets = [];
        this.listError = e.message || 'No se pudieron cargar los tickets';
      } finally {
        this.loadingList = false;
      }
    },
    async selectTicket(ticketId) {
      if (!ticketId || this.loadingDetail) return;
      this.activeTicketId = ticketId;
      this.loadingDetail = true;
      try {
        this.activeTicket = await fetchSupportTicketById(ticketId);
      } catch (e) {
        this.activeTicket = null;
        this.listError = e.message || 'No se pudo cargar el ticket';
      } finally {
        this.loadingDetail = false;
      }
    },
    async onTicketUpdated(updatedTicket) {
      this.activeTicket = updatedTicket;
      const idx = this.tickets.findIndex((t) => t.id === updatedTicket.id);
      if (idx >= 0) {
        const next = [...this.tickets];
        next[idx] = { ...next[idx], ...updatedTicket };
        this.tickets = next.sort((a, b) => this.compareTickets(a, b));
      } else {
        await this.loadTickets();
      }
    },
    compareTickets(a, b) {
      const order = { IN_PROGRESS: 0, OPEN: 1, RESOLVED: 2 };
      const sa = order[a.status] ?? 9;
      const sb = order[b.status] ?? 9;
      if (sa !== sb) return sa - sb;
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    },
  },
};
</script>
